import { object, string } from 'yup'
import { translate } from '$i18n/i18n'

export type QuantityUnit = {
	publicId: string
	name: string
	label: string
	shortLabel: string
	unit: string
	materialNodeIds?: string[]
}

export function DefaultQuantityUnit(): QuantityUnit {
	return {
		publicId: 'new',
		name: '',
		label: '',
		shortLabel: '',
		unit: '',
		materialNodeIds: [],
	}
}

export const quantityUnitSchema = object({
	name: string()
		.trim()
		.required(translate('de', 'UI.mmpv.quantities.validation.name.required', [])),
	label: string()
		.trim()
		.required(translate('de', 'UI.mmpv.quantities.validation.label.required', [])),
	unit: string()
		.trim()
		.required(translate('de', 'UI.mmpv.quantities.validation.unit.required', []))
})
